import { ReportRequest } from '@/client/reports/types/reports.type';
import {
  ChartEmptyState,
  ChartEmptyStateType,
} from '@/components/dashboards/admin';
import { usePerformanceOvertimeReports } from '@/hooks/query/reports.hook';
import { useAppSelector } from '@/hooks/store';
import { selectCurrentAccount } from '@/store/features/account/current-account.slice';
import { PhishingBarChart } from '@/ui/charts/bar-chart';
import React from 'react';
import { useTranslation } from 'react-i18next';

type PerformanceOverTimeProps = {
  filters: ReportRequest;
  isMainDashboard?: boolean;
};

export const PerformanceOverTime = ({
  filters,
  isMainDashboard,
}: PerformanceOverTimeProps) => {
  const { t } = useTranslation();
  const currentAccount = useAppSelector(selectCurrentAccount);
  const { performanceOvertime, isLoading } = usePerformanceOvertimeReports(
    currentAccount?.id as string,
    filters,
  );

  const hasNoData =
    !isLoading && (!performanceOvertime || performanceOvertime.length === 0);

  if (hasNoData) {
    return (
      <ChartEmptyState
        minHeight={510}
        type={ChartEmptyStateType.PHISHING}
        title={t('dashboard.phishing.performance.empty.title')}
        description={t('dashboard.phishing.performance.empty.description')}
      />
    );
  }

  return (
    <PhishingBarChart
      id="performance-over-time-main-dashboard"
      reportData={performanceOvertime}
      isLoading={isLoading}
      fromDate={filters.from}
      toDate={filters.to}
      isMainDashboard={isMainDashboard}
    />
  );
};
